import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getLDClient } from '@/utils/launchDarklyClient'

type FlagValue = {
  id: string
  value: any
}

export const useFeatureFlagStore = defineStore('FeatureFlagStore', () => {
  const flags = ref<FlagValue[]>()

  const getFlag = (key: string) => flags.value?.find((flag: FlagValue) => flag.id === key)

  const fetchFlags = () => {
    try {
      const ldClient = getLDClient()

      if (import.meta.env.VITE_OUTPUT_ENVIRONMENT !== 'production') {
        console.log('LD Client Initialized with Context:', ldClient?.getContext())
      }

      if (flags.value && flags.value.length > 0) {
        return
      }

      const allFlags = ldClient?.allFlags()

      setFlags(allFlags || {})
    } catch (err) {
      // LD took too long to respond
    }
  }

  const setFlags = (flagsResponse: Record<string, any>) => {
    const flagEvaluations = Object.entries(flagsResponse).map(([key, value]) => {
      return {
        id: key,
        value
      }
    })

    flags.value = [...flagEvaluations]
  }

  const setUserContext = async (outputId: string) => {
    const ldClient = getLDClient()
    return await ldClient?.identify({
      kind: 'user',
      key: outputId,
      anonymous: false
    })
  }

  return {
    fetchFlags,
    flags,
    getFlag,
    setUserContext
  }
})
